import apiClient from './client';
import { API_ROUTES } from './routes';

export interface OnboardingStatus {
  isOnboarded: boolean;
  payoutsEnabled: boolean;
}

export const onboardingApi = {
  async getStatus(): Promise<OnboardingStatus> {
    const response = await apiClient.get<{
      payoutsEnabled: boolean;
    } | null>(API_ROUTES.CONNECT.ACCOUNTS_ME);

    const account = response.data;

    if (!account) {
      return {
        isOnboarded: false,
        payoutsEnabled: false,
      };
    }

    return {
      isOnboarded: account.payoutsEnabled,
      payoutsEnabled: account.payoutsEnabled,
    };
  },
};
